// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"8f847bc9","122":"a568b991","164":"5538cb5e","364":"17509d35","462":"8531a371","569":"62c50be1","676":"632f998d","741":"3e57424b","791":"e29cd810","891":"47198b5e"}[chunkId] + ".chunk.js";
};